import { type ISelectObject } from "@/types/select";

/** 受付帳一覧検索の条件上限（lakers_backend/domains/real_estate_book/const.py と同期） */
export const MAX_FEED_STATION_COUNT = 10;
export const MAX_FEED_CITY_COUNT_WITH_TRADE = 5;

/** provideStationCodes と同じ展開ロジックで駅ID数を数える */
export const countStationIds = (selectedValues: ISelectObject[]): number => {
  let count = 0;
  selectedValues.forEach((value) => {
    count += 1;
    if (value.additional_values && value.additional_values.length > 0) {
      count += value.additional_values.length;
    }
  });
  return count;
};
